import styled from 'styled-components';
import { Radio as AntdRadio } from 'antd';

const { Group: AntGroup } = AntdRadio;

export const RadioGroup = styled(AntGroup)`
  margin: auto;
`;

const Radio = styled(AntdRadio)`
  font-size: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  & span.ant-radio {
    top: 0;
  }

  & span.ant-radio-inner {
    width: 16px;
    height: 16px;
  }

  & span.ant-radio-inner::after {
    top: 50%;
    left: 50%;
    width: 11px;
    height: 11px;
    transform: translate(-50%, -50%);
  }
`;

const LeverageWrapper = styled.div`
  width: 100%;
`;

const LeverageGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
`;

interface LeverageItemProps {
  isSelected?: boolean;
}

const LeverageItem = styled.div<LeverageItemProps>`
  background: none;
  border: none;
  min-height: 30px;

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ isSelected }) =>
    isSelected && 'padding: 4px 8px; border: 1px solid #EDEDED;'}
`;

const LeverageTextContent = styled.div`
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`;

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  margin: 0;
  font-size: 14px;
  color: #333333;

  p {
    margin: 0;
    text-wrap: nowrap;
  }

  svg {
    color: #969696;
  }
`;

const LabelLot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding-top: 2px;

  p {
    margin: 0;
    font-size: 12px;
    text-wrap: nowrap;
    color: #858585;
    margin-top: 1px;
  }
`;

export {
  LabelLot,
  LabelWrapper,
  LeverageGroup,
  LeverageItem,
  LeverageTextContent,
  LeverageWrapper,
  Radio,
};
